import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User } from '@/shared/types';

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  setAuth: (user: User, token: string) => void;
  clearAuth: () => void;
  hasPermission: (permission: string) => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      
      setAuth: (user, token) => {
        console.log('💾 [AuthStore] setAuth 被调用');
        console.log('👤 [AuthStore] 用户:', user);
        console.log('🔑 [AuthStore] Token:', token);
        
        console.log('📝 [AuthStore] 保存 token 到 localStorage');
        localStorage.setItem('admin_token', token);
        
        console.log('🔄 [AuthStore] 更新 Zustand state');
        set({ user, token, isAuthenticated: true });
        
        console.log('✅ [AuthStore] setAuth 完成');
        console.log('🔍 [AuthStore] 当前认证状态:', get().isAuthenticated);
      },
      
      clearAuth: () => {
        localStorage.removeItem('admin_token');
        set({ user: null, token: null, isAuthenticated: false });
      },
      
      hasPermission: (permission) => {
        const { user } = get();
        if (!user) return false;
        return user.role.permissions.some((p) => p.name === permission);
      },
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        user: state.user,
        token: state.token,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);
